// Chacréa — animations reveal pour les sections home.
// Scanne tout [data-ch-reveal] et leur ajoute .is-visible quand ils entrent
// dans le viewport. Idempotent — peut être chargé plusieurs fois sans souci.
(function () {
  if (window.__chacreaHomeReveal) return;
  window.__chacreaHomeReveal = true;

  function init() {
    var items = document.querySelectorAll('[data-ch-reveal]:not(.is-visible)');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    items.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor : ré-init quand une section est rechargée.
  document.addEventListener('shopify:section:load', init);
})();
